import { differenceInMonths } from 'date-fns'

import { PRICE_REVISIONS_CHART_WIDTH, PRICE_REVISIONS_YAXIS_WIDTH } from '../../earnings/constants'
import { RevisionsChartData } from '../../earnings/types'

const LEFT_MARGIN = 10
const RIGHT_MARGIN = 4

type Props = {
  chartData: RevisionsChartData
}

export function ChartMonths({ chartData }: Props) {
  const width = PRICE_REVISIONS_CHART_WIDTH - 2 * PRICE_REVISIONS_YAXIS_WIDTH - LEFT_MARGIN - RIGHT_MARGIN
  const startDate = chartData[0].date
  const endDate = chartData[chartData.length - 1].date
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const monthsDiff = differenceInMonths(endDate, startDate)

  return <div className="ml-auto mr-auto h-6" style={{ width: width }}></div>
}
